import { ApplicationsService } from "./service";
import { ApplicationsConstant } from "./constant";

export const ApplicationsActions = {
  getApplicationList,
  getApplicationListForExcel,
  getManualRiskList,
  setManualRiskList,
  getSanctionsList,
  reviewSanction,
  allSanctionReviewed,
  getDocuments,
  getApplication,
  rejectApplication,
  rejectDueSanctionList,
  requestAdditionalDocuments,
  approveRisk,
  approveBeneficiaries,
  uploadDocumentsActions,
  addRisk,
  setReviewKycStatus,
  modifyAppState,
  clearSingleAppState,
  ClearApprovedRisks,
  setMissingDocuments,
  modifyAppActions,
  confirmUploadedAgreements,
  rejectUploadedAgreement,
  getClientRisksList,
  updateRiskHit,
  getUploadedDocumentsList,
  renewKyc,
  retryPrefill
};

function getApplicationList(data, notificationMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.getApplicationList(data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_APPLICATIONS_LIST_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.GET_APPLICATIONS_LIST_SUCCESS,
      payload: data,
      ...(notificationMessage && { notify: { showSuccess: true, message: notificationMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_APPLICATIONS_LIST_ERROR, error };
  }
}

function getApplicationListForExcel(data) {
  return dispatch => {
    return ApplicationsService.getApplicationList(data).then(
      data => data,
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function failure(error) {
    return { type: ApplicationsConstant.GET_APPLICATIONS_EXCEL_LIST_ERROR, error };
  }
}

function getManualRiskList() {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.getManualRiskList().then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_MANUAL_RISK_LIST_SUCCESS };
  }

  function success(data) {
    return { type: ApplicationsConstant.GET_MANUAL_RISK_LIST_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_MANUAL_RISK_LIST_ERROR, error };
  }
}

function setManualRiskList(data, id) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.setManualRiskList(data, id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.SET_MANUAL_RISK_LIST_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.SET_MANUAL_RISK_LIST_SUCCESS };
  }

  function failure(error) {
    return { type: ApplicationsConstant.SET_MANUAL_RISK_LIST_ERROR, error };
  }
}

function getSanctionsList(id) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.getSanctionsList(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_SANCTIONS_LIST_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.GET_SANCTIONS_LIST_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_SANCTIONS_LIST_ERROR, error };
  }
}

function reviewSanction(data, id, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.reviewSanction(data, id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.REVIEW_SANCTION_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.REVIEW_SANCTION_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.REVIEW_SANCTION_ERROR, error };
  }
}

function allSanctionReviewed(id, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.allSanctionReviewed(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.ALL_SANCTION_REVIEWED_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.ALL_SANCTION_REVIEWED_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.ALL_SANCTION_REVIEWED_ERROR, error };
  }
}

function getDocuments(id) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.getDocuments(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_DOCUMENTS_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.GET_DOCUMENTS_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_DOCUMENTS_ERROR, error };
  }
}

function getUploadedDocumentsList(id) {

  return dispatch => {
    dispatch(request());

    return ApplicationsService.getUploadedDocumentsList(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_APPLICATION_UPLOADED_DOCUMENTS_LIST_ERROR, error };
  }
}

function getApplication(id) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.getApplication(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_APPLICATION_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.GET_APPLICATION_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_APPLICATION_ERROR, error };
  }
}

function rejectApplication(id, data, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.rejectApplication(id, data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.REJECT_APPLICATION_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.REJECT_APPLICATION_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.REJECT_APPLICATION_ERROR, error };
  }
}

function rejectDueSanctionList(id, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.rejectDueSanctionList(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.REJECT_DUE_SANCTION_LIST_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.REJECT_DUE_SANCTION_LIST_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.REJECT_DUE_SANCTION_LIST_ERROR, error };
  }
}

function requestAdditionalDocuments(data, id, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.requestAdditionalDocuments(data, id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.REQUEST_ADDITIONAL_DOCUMENTS_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.REQUEST_ADDITIONAL_DOCUMENTS_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.REQUEST_ADDITIONAL_DOCUMENTS_ERROR, error };
  }
}

function approveRisk(id, data) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.approveRisk(id, data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.APPROVE_RISK_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.APPROVE_RISK_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.APPROVE_RISK_ERROR, error };
  }
}

function addRisk(id, data, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.addRisk(id, data).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.ADD_RISK_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.ADD_RISK_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.ADD_RISK_ERROR, error };
  }
}

function approveBeneficiaries(id, successMessage) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.approveBeneficiaries(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.APPROVE_BENEFICIARIES_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.APPROVE_BENEFICIARIES_SUCCESS,
      payload: data,
      ...(successMessage && { notify: { showSuccess: true, message: successMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.APPROVE_BENEFICIARIES_ERROR, error };
  }
}

function uploadDocumentsActions(id, type, data) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.uploadDocuments(id, type, data).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.UPLOAD_APPLICATION_DOCUMENTS_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.UPLOAD_APPLICATION_DOCUMENTS_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.UPLOAD_APPLICATION_DOCUMENTS_ERROR, error };
  }
}

function renewKyc(id) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.renewKyc(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.RENEW_KYC_REQUEST };
  }

  function success() {
    return { type: ApplicationsConstant.RENEW_KYC_SUCCESS };
  }

  function failure(error) {
    return { type: ApplicationsConstant.RENEW_KYC_ERROR, error };
  }
}

function retryPrefill(id) {
  return dispatch => {
    dispatch(request());

    return ApplicationsService.retryPrefill(id).then(
      data => dispatch(success(data)),
      error => dispatch(failure(error))
    );
  };

  function request() {
    return { type: ApplicationsConstant.RETRY_PREFILL_REQUEST };
  }

  function success() {
    return { type: ApplicationsConstant.RETRY_PREFILL_SUCCESS };
  }

  function failure(error) {
    return { type: ApplicationsConstant.RETRY_PREFILL_ERROR, error };
  }
}

function setReviewKycStatus(id, reviewStatus, notificationMessage) {
  return dispatch => {
    dispatch(request());
    return ApplicationsService.setReviewKycStatus(id, reviewStatus).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.SET_REVIEW_KYC_STATUS_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.SET_REVIEW_KYC_STATUS_SUCCESS,
      payload: data,
      ...(notificationMessage && { notify: { showSuccess: true, message: notificationMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.SET_REVIEW_KYC_STATUS_ERROR, error };
  }
}

function setMissingDocuments(id, missingDocuments) {
  return dispatch => {
    dispatch(request());
    return ApplicationsService.setMissingDocuments(id, missingDocuments).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.SET_MISSING_DOCUMENTS_REQUEST };
  }

  function success(data) {
    return { type: ApplicationsConstant.SET_MISSING_DOCUMENTS_SUCCESS, payload: data };
  }

  function failure(error) {
    return { type: ApplicationsConstant.SET_MISSING_DOCUMENTS_ERROR, error };
  }
}

function confirmUploadedAgreements(id, notificationMessage) {
  return dispatch => {
    dispatch(request());
    return ApplicationsService.confirmUploadedAgreements(id).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.CONFIRM_UPLOADED_AGREEMENTS_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.CONFIRM_UPLOADED_AGREEMENTS_SUCCESS,
      payload: data,
      ...(notificationMessage && { notify: { showSuccess: true, message: notificationMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.CONFIRM_UPLOADED_AGREEMENTS_ERROR, error };
  }
}

function rejectUploadedAgreement(id, comment) {
  return dispatch => {
    dispatch(request());
    return ApplicationsService.rejectUploadedAgreement(id, comment).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.REJECT_UPLOADED_AGREEMENTS_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.REJECT_UPLOADED_AGREEMENTS_SUCCESS,
      payload: data
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.REJECT_UPLOADED_AGREEMENTS_ERROR, error };
  }
}

function getClientRisksList(id) {
  return dispatch => {
    dispatch(request());
    return ApplicationsService.getClientRisksList(id).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.GET_CLIENT_RISKS_LIST_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.GET_CLIENT_RISKS_LIST_SUCCESS,
      payload: data
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.GET_CLIENT_RISKS_LIST_ERROR, error };
  }
}

function updateRiskHit(formData, id, notificationMessage) {
  return dispatch => {
    dispatch(request());
    return ApplicationsService.updateRiskHit(formData, id).then(
      data => dispatch(success(data)),
      error => {
        dispatch(failure(error));
        throw error;
      }
    );
  };

  function request() {
    return { type: ApplicationsConstant.UPDATE_RISK_HIT_REQUEST };
  }

  function success(data) {
    return {
      type: ApplicationsConstant.UPDATE_RISK_HIT_SUCCESS,
      payload: data,
      ...(notificationMessage && { notify: { showSuccess: true, message: notificationMessage } })
    };
  }

  function failure(error) {
    return { type: ApplicationsConstant.UPDATE_RISK_HIT_ERROR, error };
  }
}

function modifyAppState(newStatus) {
  return dispatch => {
    dispatch(modifyState(newStatus));
  };

  function modifyState(status) {
    return { type: ApplicationsConstant.MODIFY_SELECTED_APP_STATE, payload: status };
  }
}

function modifyAppActions(newActions) {
  return dispatch => {
    dispatch(modifyAppActions(newActions));
  };

  function modifyAppActions(actions) {
    return { type: ApplicationsConstant.MODIFY_SELECTED_APP_ACTIONS, payload: actions };
  }
}

function clearSingleAppState() {
  return dispatch => {
    dispatch(clearSingleAppState());
  };

  function clearSingleAppState() {
    return { type: ApplicationsConstant.CLEAR_SINGLE_APP_STATE };
  }
}

function ClearApprovedRisks() {
  return dispatch => {
    dispatch(ClearApprovedRisks());
  };

  function ClearApprovedRisks() {
    return { type: ApplicationsConstant.CLEAR_APPROVED_RISKS };
  }
}
